module.exports = __webpack_public_path__ + "static/media/Team 9 - OZistant.0f0d0f04.png";